export default {"src":"/_next/static/media/Airport.32ebee45.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};